import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class BizdevSalesAgentService {
    private base = `${environment.apiUrl}/report-dashboard`;

    constructor(private http: HttpClient) {}

    getSalesAgents() {
        return this.http.get<any>(`${this.base}/sales-agents`);
    }

    addSalesAgent(userId: number) {
        return this.http.post<any>(`${this.base}/sales-agents/${userId}`, {});
    }

    removeSalesAgent(userId: number) {
        return this.http.delete<any>(`${this.base}/sales-agents/${userId}`);
    }

    searchUsers(q: string) {
        return this.http.get<any>(`${this.base}/users/search`, { params: { q } });
    }
}
